package pl.decks.chartjs.value

sealed class FillValue {
    object None : FillValue()
    object Origin : FillValue()
    object Start : FillValue()
    object End : FillValue()
    object Stack : FillValue()
    data class Relative(val offset: Int) : FillValue()

    internal fun toChartJs() : dynamic = when (this) {
        is None -> false.asDynamic()
        is Origin -> "origin".asDynamic()
        is Start -> "start".asDynamic()
        is End -> "end".asDynamic()
        is Stack -> "stack".asDynamic()
        is Relative -> (if (offset >= 0) "+$offset" else "$offset").asDynamic()
    }
}
